const features = [
  {
    icon: 'ri-shield-check-line',
    title: '多源核验',
    desc: '每条吃瓜资讯均经过至少两个独立信源验证后发布，标注来源和可信度等级，让你吃真瓜、不吃假瓜。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '极速更新',
    desc: '编辑团队全天候监测娱乐热点，重大事件 15 分钟内上线快讯，确保你永远是朋友圈里第一个吃到瓜的人。',
  },
  {
    icon: 'ri-stack-line',
    title: '专题合集',
    desc: '九大专题板块覆盖影视、综艺、明星、恋情等全部吃瓜维度，时间线清晰完整，追瓜不费力。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            为什么选择今日大瓜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">三大核心优势，打造靠谱吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {features.map((item, idx) => (
            <div key={idx} className="text-center p-6 md:p-8">
              <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                <i className={`${item.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}